import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";
import _environment from "../_environment/_environment";

console.log(`[Firebase] App started in ${process.env.REACT_APP_ENV} mode`);
firebase.initializeApp(_environment.firebase.config);

if (process.env.REACT_APP_ENV === "production" || process.env.REACT_APP_ENV === "staging") {
  firebase.analytics();
}

export default firebase;
